module.exports = __webpack_public_path__ + "img/banner_img.078d1ff2.png";